// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zH5t","title":"Header_title__1nIHG","side":"Header_side__3c1NW"};